import { formatResultsDate } from "../../../../../functions/functions";
import "./middle.sass";

/**
 * Renderiza la sección central de la tarjeta con información de marcador, fecha o estado del evento.
*/
export default function Middle({
  liga, date, period_title,
  left_score, left_class,
  right_score, right_class, clase
}) {

  const isPlaying = ["clarosports-finished-game", "clarosports-in-progress-game"].includes(clase);
  // Devuelve clases CSS condicionales para los marcadores
  const getScoreClass = (baseClass, teamClass) =>
    `${baseClass} ${teamClass === 'clarosports-winner' ? 'score-ganador' : 'score-perdedor'}`;

  // Renderiza contenido para partidos próximos
  const renderNextGame = () => (
    <>
      <span className="middle-date">{formatResultsDate(date)}</span>
      <span className="middle-label">{liga}</span>
    </>
  );

  // Renderiza mensaje de error
  const renderError = () => (
    <div className="middle-list__error">
      <span>{period_title}</span>
    </div>
  );

  return (
    <div className={`teamlist middle-list${isPlaying ? ' team_playing' : ''}`}>
      {clase === "clarosports-next-game" && renderNextGame()}

      {isPlaying &&
        <div className="middle-list__score">
          <div className={getScoreClass('middle-list__scoreL', left_class)}>{left_score}</div>
          <div className={getScoreClass('middle-list__scoreR', right_class)}>{right_score}</div>
        </div>
      }

      {(clase === 'clarosports-error-game') && renderError()}
    </div>
  )
}